<template>
  <v-layout
    row
    wrap
  >
    <v-flex xs12>
      <persona-datos-basicos v-bind:solo-lectura="soloLectura"></persona-datos-basicos>
    </v-flex>

    <v-flex
      xs12
      md6
    >
      <persona-documentos-identidad v-bind:solo-lectura="soloLectura"></persona-documentos-identidad>
    </v-flex>

    <v-flex
      xs12
      md6
    >
      <persona-emails v-bind:solo-lectura="soloLectura"></persona-emails>
    </v-flex>

    <v-flex
      xs12
      md6
    >
      <persona-telefonos v-bind:solo-lectura="soloLectura"></persona-telefonos>
    </v-flex>

    <v-flex
      xs12
      md6
    >
      <persona-domicilios v-bind:solo-lectura="soloLectura"></persona-domicilios>
    </v-flex>
  </v-layout>
</template>

<script>

import PersonaDatosBasicos from './VPersonaDatosBasicos'
import PersonaDocumentosIdentidad from './VPersonaDocumentosIdentidad'
import PersonaEmails from './VPersonaEmails'
import PersonaTelefonos from './VPersonaTelefonos'
import PersonaDomicilios from './VPersonaDomicilios'

export default {
  name: 'VPersona',
  components: {
    PersonaDatosBasicos,
    PersonaDocumentosIdentidad,
    PersonaEmails,
    PersonaTelefonos,
    PersonaDomicilios
  },
  props: {
    permiso: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      titulo: 'Persona',
      soloLectura: !this.$puedo(this.permiso + ':modif')
    }
  }
}
</script>

<style lang="scss" scoped>
.lista-detalle-seccion {
  dt {
    font-size: 14px !important;
    font-weight: 500;
  }
  dd {
    font-size: 13px !important;
    font-weight: 400;
    margin-bottom: 10px;
  }
}
</style>
